import { generateCode } from '../../../utils/code'
import { generateUuid } from '../../../utils/uuids'
import {
  ProgramManagementRow,
  ProgramManagementRowType,
  PROGRAM_MANAGEMENT_ROW_TYPE,
} from './programManagement'

const isGroupRow = (row: ProgramManagementRow): boolean =>
  row.type === PROGRAM_MANAGEMENT_ROW_TYPE.GROUP

const isProjectRow = (row: ProgramManagementRow): boolean =>
  row.type === PROGRAM_MANAGEMENT_ROW_TYPE.PROJECT

const isProgramRow = (row: ProgramManagementRow): boolean =>
  row.type === PROGRAM_MANAGEMENT_ROW_TYPE.PROGRAM

const isDraggableRow = (row: ProgramManagementRow): boolean =>
  isGroupRow(row) || isProjectRow(row)

/** 予定日を編集できる行か（プログラム行・グループ行は自身の予定日を持てる） */
const isScheduledDateEditable = (row: ProgramManagementRow): boolean =>
  isGroupRow(row) || isProgramRow(row)

const canAcceptChild = (
  parentType: ProgramManagementRowType,
  childType: ProgramManagementRowType
): boolean => {
  if (parentType === PROGRAM_MANAGEMENT_ROW_TYPE.PROGRAM) {
    // プログラム直下にグループだけでなくプロジェクトも移動できるようにする
    return (
      childType === PROGRAM_MANAGEMENT_ROW_TYPE.GROUP ||
      childType === PROGRAM_MANAGEMENT_ROW_TYPE.PROJECT
    )
  }
  if (parentType === PROGRAM_MANAGEMENT_ROW_TYPE.GROUP) {
    return (
      childType === PROGRAM_MANAGEMENT_ROW_TYPE.GROUP ||
      childType === PROGRAM_MANAGEMENT_ROW_TYPE.PROJECT
    )
  }
  return false
}

const createNewGroupRow = (existingCodes: string[]): ProgramManagementRow => {
  const uuid = generateUuid()
  return {
    uuid,
    lockVersion: 0,
    treeValue: [],
    type: PROGRAM_MANAGEMENT_ROW_TYPE.GROUP,
    groupUuid: generateUuid(),
    code: generateCode(existingCodes),
    displayName: '',
    added: true,
    edited: true,
  }
}

export const programItemRowService = {
  isGroupRow,
  isProjectRow,
  isProgramRow,
  isDraggableRow,
  isScheduledDateEditable,
  canAcceptChild,
  createNewGroupRow,
}
